import {
  LuCalculator,
  LuCalendar,
  LuChevronDown,
  LuFormInput,
  LuHeading1,
  LuMail,
  LuMinus,
  LuPhone,
  LuText,
} from 'react-icons/lu';

const FIELD_TYPE_OPTIONS = [
  {
    value: 'text',
    label: 'Texto pequeno',
    icon: <LuText />,
    defaultName: 'Campo de Texto Simples',
  },
  {
    value: 'textarea',
    label: 'Texto grande',
    icon: <LuText />,
    defaultName: 'Campo de Texto Multilinha',
  },
  {
    value: 'email',
    label: 'Email',
    icon: <LuMail />,
    defaultName: 'Campo de Email',
  },
  {
    value: 'phone',
    label: 'Telefone',
    icon: <LuPhone />,
    defaultName: 'Campo de Telefone',
  },
  {
    value: 'date',
    label: 'Data',
    icon: <LuCalendar />,
    defaultName: 'Campo de Data',
  },
  {
    value: 'number',
    label: 'Numérico',
    icon: <LuCalculator />,
    defaultName: 'Campo Numérico',
  },
  {
    value: 'select',
    label: 'Lista Suspensa',
    icon: <LuChevronDown />,
    defaultName: 'Campo de Lista Suspensa',
  },
  {
    value: 'cpf',
    label: 'CPF',
    icon: <LuFormInput />,
    defaultName: 'Campo de CPF',
  },
  {
    value: 'cnpj',
    label: 'CNPJ',
    icon: <LuFormInput />,
    defaultName: 'Campo de CNPJ',
  },
  // {
  //   value: 'boolean',
  //   label: 'Sim ou Não (Booleano)',
  //   icon: <LuChevronDown />,
  //   defaultName: 'Campo Sim ou Não',
  // },
  // {
  //   value: 'checkbox',
  //   label: 'Checkbox',
  //   icon: <LuBoxSelect />,
  //   defaultName: 'Campo de Checkbox',
  // },
  // {
  //   value: 'radio',
  //   label: 'Radio Buttons',
  //   icon: <LuRadio />,
  //   defaultName: 'Campo de Radio Buttons',
  // },
  {
    value: 'heading',
    label: 'Título de Seção',
    icon: <LuHeading1 />,
    defaultName: 'Título de Seção',
  },
  {
    value: 'divider',
    label: 'Separador',
    icon: <LuMinus />,
    defaultName: 'Separador',
  },
];

const COLUMN_SIZE_OPTIONS = [
  { value: 12, label: '100% - Ocupar toda linha' },
  { value: 6, label: '50% - Metade da linha' },
  { value: 4, label: '33% - Um terço da linha' },
  { value: 3, label: '25% - Um quarto da linha' },
];

const YES_NO_OPTIONS = [
  { value: 'Não', label: 'Não' },
  { value: 'Sim', label: 'Sim' },
];

export { FIELD_TYPE_OPTIONS, COLUMN_SIZE_OPTIONS, YES_NO_OPTIONS };
